// @ts-check
import React from 'react';
import { Box, useTheme } from '../../pdf-design-system';

/**
 * A vertical stack that adds some space between its children.
 *
 * @param {{
 *  space?: number;
 *  style?: import('@react-pdf/types').Style;
 *  children: React.ReactNode;
 *  [x: string]: any;
 * }} props
 * @returns
 */
export default function Stack({ space = 1, style, children, debug, ...rest }) {
  const { theme } = useTheme();
  const spacing = theme.space?.[space];
  const visibleChildren = React.Children.toArray(children)
    // @ts-ignore Not all children have props.
    .filter((child) => !child?.props?.hide);
  return (
    <Box
      style={[
        { display: 'flex', marginVertical: spacing != null && `-${spacing}` },
        style,
      ]}
      {...rest}
    >
      {visibleChildren.map((child) => (
        <Box
          // @ts-ignore Not all children have keys.
          key={child?.key}
          debug={debug}
          style={{ paddingVertical: spacing }}
        >
          {child}
        </Box>
      ))}
    </Box>
  );
}
